<template>
    <div class="flex justify-between p-4">
      <textarea v-model="markdown" 
                class="w-1/2 h-64 p-3 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50 shadow"
                placeholder="Enter markdown">
      </textarea>
      <div v-html="renderedMarkdown" 
           class="w-1/2 border border-slate-700 rounded-lg shadow p-3 bg-slate-900 text-slate-200 overflow-auto prose prose-invert">
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, computed, ref } from 'vue';
  import MarkdownIt from 'markdown-it';
  
  export default defineComponent({
    name: 'MarkdownEditor',
    setup() {
      const markdown = ref('');
      const md = new MarkdownIt();
  
      const renderedMarkdown = computed(() => {
        return md.render(markdown.value);
      });
  
      return { markdown, renderedMarkdown };
    }
  });
  </script>
  
  <style>
  /* Tailwind CSS styles or any other custom styles */
  </style>
  